export const getFidelityPoints = (price: number) => Math.floor(price / 5)

export const getFidelityPointsLabel = (price: number, getLabel: any) => {
  const points = getFidelityPoints(price)
  if (points === 1) {
    return `${points} ${getLabel("basket", "fidelity-point")}`
  }

  return `${points} ${getLabel("basket", "fidelity-points")}`
}
